export default function getChainID(currency) {
    // Supported Chain ID
    const ethereumChainID = process.env.NEXT_PUBLIC_CHAIN_ID;
    const polygonChainID = process.env.NEXT_PUBLIC_POLYGON_CHAIN_ID;
    return currency === 'MATIC' ? polygonChainID : ethereumChainID;
}
